module.exports = __webpack_public_path__ + "static/AThomson-965a7b2642c0f03fa1132137ea3f1b8b.jpg";